import { Blockchains } from "./types";

import Ethereum from "./chains/ethereum";
import Tron from "./chains/tron";

export const getChainByTransport = (blockchain, transport) => {
    switch (blockchain) {
        case Blockchains.ETH:
            return new Ethereum(transport);
        case Blockchains.TRX:
            return new Tron(transport);
        default:
            return null;
    }
};